import { render, staticRenderFns } from "./SecStudy_SKMG14.vue?vue&type=template&id=b1b6b092&scoped=true&"
import script from "./SecStudy_SKMG14.vue?vue&type=script&lang=js&"
export * from "./SecStudy_SKMG14.vue?vue&type=script&lang=js&"
import style0 from "./SecStudy_SKMG14.vue?vue&type=style&index=0&id=b1b6b092&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b6b092",
  null
  
)

export default component.exports